
import { ServiceType } from './types';

/**
 * Определяет тип сервиса по URL
 */
export const detectService = (url: string): ServiceType | undefined => {
  if (url.includes('supabase.co')) {
    if (url.includes('/storage/')) {
      return 'supabaseStorage';
    }
    return 'supabase';
  }
  
  if (url.includes('googleapis.com') || url.includes('maps.google')) {
    if (url.includes('geocode')) {
      return 'geocoding';
    }
    return 'googleMaps';
  }
  
  if (url.includes('hook.eu1.make.com') || url.includes('hook.us1.make.com') || 
      url.includes('hook.eu2.make.com') || url.includes('hook.us2.make.com') ||
      url.includes('make.com/webhook') || url.includes('.make.com')) {
    return 'makeWebhooks';
  }
  
  // Если URL содержит webhook в пути, считаем это общим webhook
  if (url.includes('webhook') || url.includes('hook')) {
    return 'webhooks';
  }
  
  return undefined;
};

/**
 * Извлекает путь из Make.com webhook URL
 * @param url - Оригинальный Make.com webhook URL
 * @returns Путь для добавления к прокси URL
 */
export const extractMakeWebhookPath = (url: string): string => {
  try {
    const urlObj = new URL(url);
    
    // Проверяем что это действительно Make.com URL
    if (!urlObj.hostname.includes('make.com')) {
      console.warn('⚠️ URL не является Make.com webhook:', url);
      return '';
    }
    
    // Возвращаем путь (например, /nunfd1olha2rxivbibb0vtvsyuka4coy)
    const path = urlObj.pathname;
    console.log(`🔧 Извлечен путь из Make.com URL: ${url} -> ${path}`);
    
    return path;
  } catch (error) {
    console.error('❌ Ошибка парсинга Make.com URL:', url, error);
    return '';
  }
};

/**
 * Проверяет, является ли URL Make.com webhook
 */
export const isMakeWebhookUrl = (url: string): boolean => {
  return url.includes('hook.eu1.make.com') || 
         url.includes('hook.us1.make.com') || 
         url.includes('hook.eu2.make.com') || 
         url.includes('hook.us2.make.com') ||
         url.includes('make.com/webhook') || 
         (url.includes('.make.com') && url.includes('hook'));
};
